import {
  BG_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import { SvgProps } from "react-native-svg";

interface BenefitCardProps {
  title: string;
  description: string;
  icon: React.ComponentType<SvgProps>;
}

const BenefitCard = ({ title, description, icon: Icon }: BenefitCardProps) => {
  const { t } = useTranslation();
  return (
    <View style={[COMMON_STYLES.row, COMMON_STYLES.alignItemsStart]}>
      <View style={[COMMON_STYLES["mr3/2"]]}>
        <Icon width={48} height={48} />
      </View>
      <View style={[COMMON_STYLES.flex1]}>
        <Text
          style={[
            TEXT_STYLES.textNeutral90,
            TYPOGRAPHY.TEXT1,
            VARIANTS_STYLES.EMPHASIZED,
          ]}
        >
          {t(title)}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            TEXT_STYLES.textNeutral90,
            COMMON_STYLES["mt1/2"],
          ]}
        >
          {t(description)}
        </Text>
      </View>
    </View>
  );
};

export default BenefitCard;
